import { render, staticRenderFns } from "./TransferInventory.vue?vue&type=template&id=c42e42a4&scoped=true"
import script from "./TransferInventory.vue?vue&type=script&lang=js"
export * from "./TransferInventory.vue?vue&type=script&lang=js"
import style0 from "./TransferInventory.vue?vue&type=style&index=0&id=c42e42a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42e42a4",
  null
  
)

export default component.exports